import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SimpleFlexbox, SimpleAutoCompleteCombo } from 'ctm-components';
import { nonStandardAccessoriesDropDownOptions } from '../../core/state_selectors';
import styles from './non_std_accessories.css';

const placeholderOptions = [
    {
        label: 'Please choose value...',
        value: ''
    }
];

class _AddNonStdAccessory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            inputValue: ''
        };
    }

    /**
     * The event fired when the suggestion is clicked
     * @param {Event} event The onSelect Event
     * @param {Object} suggestion The suggestion selected
     */
    onSelectAccessory = (event, { suggestion }) => {
        const { addAccessory } = this.props;
        const code = suggestion.code;
        this.setState({ inputValue: '' });
        addAccessory({ code });
    };

    /**
     * The event fired when the AutoSuggest value is changed
     * @param {Event} event The onChange Event
     * @param {String} newValue The new value that is typed
     */
    onInputChange = (event, { newValue }) => {
        const newState = {
            inputValue: newValue
        };
        this.setState(newState);
    };

    /**
     * Renders the NonStandardAccessories component
     * @return {Node} Returns the NonStandardAccessories component
     */
    render = () => {
        const { accessories } = this.props;
        const { inputValue } = this.state;
        return (
            <SimpleFlexbox display="flex" className={styles.accessory_picker_container}>
                <SimpleAutoCompleteCombo
                    placeholder="Start typing..."
                    className={styles.auto_suggest_container}
                    onChange={this.onInputChange}
                    value={inputValue}
                    onSuggestionSelected={this.onSelectAccessory}
                    suggestions={accessories}
                    focusInputOnSuggestionClick={false}
                />
            </SimpleFlexbox>
        );
    };

}

_AddNonStdAccessory.propTypes = {
    addAccessory: PropTypes.func,
    accessories: PropTypes.array
};

/**
 * Maps state to props
 * @param {Object} state The redux state
 * @return {Object} Mapped state to props
 */
const mapStateToProps = (state) => {
    return {
        accessories: nonStandardAccessoriesDropDownOptions(state)
    };
};

/**
 * @todo: move actions to action creators
 * Map dispatch function to component props
 * @param {Function} dispatch - store's dispatch function
 * @returns {Object} props that contain addAccessory function
 */
const mapDispatchToProps = (dispatch) => ({
    addAccessory: (item) => {
        dispatch({
            type: 'SET_VALUE_IN_ARRAY',
            value: item,
            stateKey: 'vertical.quote',
            identifier: 'coverDetail.vehicle.nonStandardAccessories'
        });
    }
});

const AddNonStdAccessory = connect(mapStateToProps, mapDispatchToProps)(_AddNonStdAccessory);

export { AddNonStdAccessory, _AddNonStdAccessory, placeholderOptions };
